/**
 * API Configuration
 * 
 * This file defines all API endpoints and their sources.
 * 
 * DATA SOURCES:
 * 1. CRM (comp.extranetsync.com) - Single source of truth for:
 *    - Leads
 *    - Properties
 * 
 * 2. Local Backend - Used for:
 *    - Authentication (CRM doesn't have auth endpoints)
 *    - Bookings (CRM doesn't have booking endpoints)
 *    - App-specific features
 */

// CRM Configuration - Primary data source
export const CRM_CONFIG = {
  BASE_URL: process.env.REACT_APP_CRM_API_URL,
  API_KEY: process.env.REACT_APP_CRM_API_KEY,
  TIMEOUT: 30000,
};

// Local Backend Configuration - For auth and bookings
export const LOCAL_CONFIG = {
  BASE_URL: process.env.REACT_APP_BACKEND_URL,
  TIMEOUT: 60000,
};

// Endpoint mapping - Which API to use for what
export const ENDPOINT_SOURCE = {
  // CRM endpoints (live data)
  leads: 'CRM',
  properties: 'CRM',
  
  // Local backend endpoints
  auth: 'LOCAL',
  bookings: 'LOCAL',
  calendar: 'LOCAL',
  analytics: 'LOCAL',
  notifications: 'LOCAL',
};

export default {
  CRM_CONFIG,
  LOCAL_CONFIG,
  ENDPOINT_SOURCE,
};
